import { IIconBase } from '..'

const modalWarningIcon = ({
  color = '#664D03',
  height = 40,
  width = 41,
}: IIconBase) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 41 40'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g id='vuesax/linear/info-circle'>
        <g id='info-circle'>
          <path
            id='Vector'
            d='M20.4997 36.6673C29.6663 36.6673 37.1663 29.1673 37.1663 20.0007C37.1663 10.834 29.6663 3.33398 20.4997 3.33398C11.333 3.33398 3.83301 10.834 3.83301 20.0007C3.83301 29.1673 11.333 36.6673 20.4997 36.6673Z'
            stroke={color}
            strokeWidth='2.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            id='Vector_2'
            d='M20.5 13.334V21.6673'
            stroke={color}
            strokeWidth='2.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            id='Vector_3'
            d='M20.4912 26.666H20.5062'
            stroke={color}
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </g>
      </g>
    </svg>
  )
}

export default modalWarningIcon
